import { SubHeader } from "layout/SubHeader";
import React, { useState } from "react";

import moment from "moment";
import { useEffect } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import MyModal from "../../../components/MyModal";
import NotAuthorized from "../../../components/NotAuthorized";
import "../index.scss";
import NewBatchBillinCharge from "../NewBatchBillinCharge";
import NewCharge from "../NewCharge";
import UserContext from "../NewChargeContext";
import {
  DepositsTabel,
  FiltterDeposits,
  PeddingFillter,
  PeddingTable,
} from "./components";
import DepositsRadioTabs from "./DepositsRadioTabs";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import CrossSvg from "assets/icons/svg/cross";
import Button from "components/button/Button";

const storageData = JSON.parse(
  localStorage.getItem("organization") !== "undefined"
    ? localStorage.getItem("organization")
    : "{}"
);

const initialFilters = {
  filter: {
    syncedBatch: true,
    method: "all",
    paid_at: "",
    showZero: false,
  },

  status:
    storageData?.quickBooks_information?.accountType === "cash"
      ? "payment"
      : "charge",
};

export const Deposits = ({ setBatchList }) => {
  const [toggle, setToggle] = useState("Awaiting To Batch");
  const [stepOne, setStepOne] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pendingFilter, setPendingFilter] = useState({});
  const [sortData, setSortData] = useState(initialFilters);
  const [data, setData] = useState({});
  const [isSaved, setSaved] = useState(false);
  const [hfinish, setHFinish] = useState(false);
  const [open, setOpen] = useState(false);
  const [localFormat, setLocalFormat] = useState(false);
  const [isFinanceActive, setIsFinanceActive] = useState(true);
  const [openBatch, setOpenBatch] = useState(false);
  const [batchId, setBatchId] = useState(null);
  const [editData, setEditData] = useState({});
  const [searchValue, setSearchValue] = React.useState("");
  const [awatingType, setTypeAwating] = useState("charge");
  const [pendingType, setTypePending] = useState("Pending");
  const [page, setPage] = useState(0);
  const [dueDateRange, setDueDateRange] = useState([null, null]);
  const [startDue, endDue] = dueDateRange;
  const [goFilter, setGoFilter] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openBatchFilter, setOpenBatchFilter] = useState(false);


  useEffect(() => {
    if (dueDateRange[0] !== null) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          charge_date: {
            start: moment(startDue).format('MM/DD/YYYY'),
            end: moment(endDue).format('MM/DD/YYYY'),
          },
        },
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          charge_date: "",
        },
      }));
    }
  }, [dueDateRange]);

  const pendingSwitchType = (pendingType) => {
    setTypePending(pendingType);
    setPendingFilter((prev) => ({
      ...prev,
      filter: {
        date: "",
      },
      search: "",
    }));
  };

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev?.sort?.[e] === 1 ? -1 : 1,
      }
    }));
  };
  const onSearchChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      search: e?.target?.value ? e?.target?.value : "",
    }));
  };
  const onSearchChangePendding = (e) => {
    setPage(0);

    setPendingFilter((prev) => ({
      ...prev,
      search: e?.target?.value ? e?.target?.value : "",
    }));
  };
  useEffect(() => {
    setSortData((prev) => ({
      ...prev,
      search: searchValue ? searchValue : "",
    }));
  }, [searchValue]);

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (dateRange[0] !== null) {

      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          paid_at: {
            start: moment(startDate).format('MM/DD/YYYY'),
            end: moment(endDate).format('MM/DD/YYYY'),
          },
        },
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          paid_at: "",
        },
      }));
    }
  }, [dateRange]);

  const onPaidDateChange = (e) => {
    // setPage(0);
    console.log(e);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        paid_at: e,
      },
    }));
  };

  const [date, setDate] = React.useState(null);


  const onPaidDateChangePendding = (e) => {
    if (e === null) {
      setDate(e)
      setPage(0);
      setLocalFormat(true);
      setPendingFilter((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          date: "",
        },
      }));
    } else {
      const date = new Date(e);
      setDate(e)
      setPage(0);
      setLocalFormat(true);
      setPendingFilter((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          date: e ? moment(date).format("YYYY-MM-DD") : "",
        },
      }));
    }
  };

  const onLedgerAccountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        ledger: e,
      },
    }));
  };

  const onAmountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        amount: e ? e : undefined,
      },
    }));
  };
  const onSubLedgerAccountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        subLedger: e,
      },
    }));
  };

  const onPayNowClick = ({ detail }) => {
    setData({
      ...detail,
      awatingType: "pay-now",
    });
    setOpen(true);
  };

  useEffect(() => {
    document.addEventListener("pay-now", onPayNowClick);
    return () => document.removeEventListener("pay-now", onPayNowClick);
  }, []);

  const onModalClose = () => {
    if (isSaved || hfinish) {
      closeModal();
    } else {
      closeModal();
    }
  };

  const closeModal = () => {
    setStepOne(true);
    setOpen(false);
    setOpenBatch(false);
  };

  const { push } = useHistory();
  const handleClick = (tab, batch_id = null) => {
    if (batch_id) {
      setBatchId(batch_id);
    } else {
      setBatchId(null);
    }
    setToggle(tab);
    if (tab === "Batches") {
      push({
        pathname: "/finance/deposits/pending",
      });
    } else {
      push({
        pathname: "/finance/deposits",
      });
    }
  };
  useEffect(() => {
    if (searchValue === "") {
      // fetchMyAPI();
    } else {
      setSearchValue(searchValue);
    }
  }, [searchValue]);
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/finance/deposits") {
      setOpenBatch(false);

      setToggle("Awaiting To Batch");
    } else if (pathname === "/finance/deposits/pending") {
      setToggle("Batches");
    }
  });

  useEffect(() => {
    setFilters({
      filter: {
        syncedBatch: true,
        method: "all",
        paid_at: "",
        showZero: false,
      },

      status: filters.status,
    });
  }, [toggle]);

  const tabOptions = ["Awaiting To Batch", "Batches"];

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "finance") {
        return setIsFinanceActive(item?.active);
      }
    });
  }, []);
  return isFinanceActive == false ? (
    <NotAuthorized title={"Reports"} />
  ) : (
    <div className="members pr-3 pr-sm-12 pt-10">
      {toggle === "Awaiting To Batch" ? (
        <>
          <div className="filteration">
            <div className="activated-ledger d-flex flex-column flex-lg-row justify-content-between align-items-center mb-5">
              <div className="toggle-bar ml-3">
                <DepositsRadioTabs
                  handleChange={handleClick}
                  value={toggle}
                />
              </div>
              <div className="pr-5">
                <Button
                  style={openFilter ? { opacity: 0.3 } : {}}
                  variant="filter"
                  onClick={() => setOpenFilter((o) => !o)}
                >
                  <FilterIcon />
                  <span>Filter</span>
                </Button>
              </div>
            </div>
            {openFilter && (
              <div className="filter mb-10">
                <div className="text-right px-5 pt-5">
                  <span className="cursor-pointer" onClick={() => setOpenFilter(false)}>
                    <CrossSvg />
                  </span>
                </div>
                <div className="px-9 pb-5">
                  <FiltterDeposits
                    onSearchChange={onSearchChange}
                    filter={filters}
                    setFilters={setFilters}
                    onLedgerAccountChange={onLedgerAccountChange}
                    onSubLedgerAccountChange={onSubLedgerAccountChange}
                    onPaidDateChange={onPaidDateChange}
                    setDateRange={setDateRange}
                    startDate={startDate}
                    endDate={endDate}
                    onAmountChange={onAmountChange}
                    type={awatingType}
                    dueDateRange={dueDateRange}
                    setDueDateRange={setDueDateRange}
                    startDue={startDue}
                    endDue={endDue}
                    setGoFilter={setGoFilter}
                    goFilter={goFilter}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="charges-table">
            <DepositsTabel
              filters={filters}
              sortCharged={sortCharged}
              batch_id={batchId}
              setFilters={setFilters}
              switchType={setTypeAwating}
              type={awatingType}
              pendingType={pendingType}
              page={page}
              setPage={setPage}
              setGoFilter={setGoFilter}
              goFilter={goFilter}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            />
          </div>
        </>
      ) : toggle === "Batches" && openBatch === false ? (
        <Route path="/finance/deposits/pending">
          <>
            <div className="filteration">
              <div className="activated-ledger d-flex flex-column flex-lg-row justify-content-between align-items-center mb-5">
                <div className="toggle-bar ml-3">
                  <DepositsRadioTabs
                    handleChange={handleClick}
                    value={toggle}
                  />
                </div>
                <div className="pr-5">
                  <Button
                    style={openBatchFilter ? { opacity: 0.3 } : {}}
                    variant="filter"
                    onClick={() => setOpenBatchFilter((o) => !o)}
                  >
                    <FilterIcon />
                    <span>Filter</span>
                  </Button>
                </div>
              </div>
              {openBatchFilter && (
                <div className="filter mb-10">
                  <div className="text-right px-5 pt-5">
                    <span className="cursor-pointer" onClick={() => setOpenBatchFilter(false)}>
                      <CrossSvg />
                    </span>
                  </div>
                  <div className="px-9 pb-5">
                    <PeddingFillter
                      filter={pendingFilter}
                      pendingType={pendingType}
                      onSearchChange={onSearchChangePendding}
                      onPaidDateChange={onPaidDateChangePendding}
                      date={date}
                      setDate={setDate}
                      localFormat={localFormat}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="Billing-table">
              <PeddingTable
                filters={pendingFilter}
                sortCharged={sortCharged}
                switchType={pendingSwitchType}
                type={pendingType}
                setFilters={setPendingFilter}
                pendingType={pendingType}
                awatingType={awatingType}
                page={page}
                setPage={setPage}
              />
            </div>
          </>
        </Route>
      ) : toggle === "Batches" && openBatch === true ? (
        <UserContext.Provider value={{ editData }}>
          <NewBatchBillinCharge
            setStepOne={setStepOne}
            handleClose={onModalClose}
            closeModal={onModalClose}
            data={data}
            activeIndex={editData ? 0 : 0}
            setSaved={setSaved}
            handleClick={handleClick}
            editData={editData}
          />
        </UserContext.Provider>
      ) : (
        "Reports"
      )}
      <MyModal
        className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
        open={open}
        onClose={onModalClose}
      >
        <UserContext.Provider value={{ hfinish, setHFinish }}>
          <NewCharge
            setStepOne={setStepOne}
            handleClose={onModalClose}
            data={data}
            activeIndex={data?.awatingType === "pay-now" ? 1 : 0}
            setSaved={setSaved}
            setBatchList={setBatchList}
          />
        </UserContext.Provider>
      </MyModal>
      {/* <MyModal
        className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
        open={openBatch}
        onClose={onModalClose}
      >
        <UserContext.Provider value={{ hfinish, setHFinish }}> */}

      {/* </UserContext.Provider>
      </MyModal> */}
    </div>
  );
};
